import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { materialApi } from '@/lib/api/services/material.api';
import type { CreateMaterialInput } from '@/types/material';

export function useMaterials(search?: string, enabled = true) {
  return useQuery({
    queryKey: ['materials', search],
    queryFn: () => materialApi.getAll({ search, limit: 50 }),
    enabled,
    staleTime: 60 * 1000,
  });
}

/**
 * One material by id, for the detail route. `['materials', 'detail', id]`
 * starts with `['materials']` on purpose — every existing edit mutation
 * already invalidates that prefix, so this refetches for free.
 */
export function useMaterial(id: number | undefined, enabled = true) {
  return useQuery({
    queryKey: ['materials', 'detail', id],
    queryFn: () => materialApi.getById(id as number),
    enabled: enabled && id != null,
  });
}

export function useCreateMaterial() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateMaterialInput) => materialApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['materials'] });
    },
  });
}
